/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherThermometerIcon24Solid = forwardRef('WeatherThermometerIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.75 5.5a4.25 4.25 0 0 1 8.5 0v5.832a6.5 6.5 0 1 1-8.5 0V5.5ZM12 7a1 1 0 0 1 1 1v5.42a3.001 3.001 0 0 1-1 5.83 3 3 0 0 1-1-5.83V8a1 1 0 0 1 1-1Z" })));
});
